if (!customElements.get('cis-scroll-hero')) {

  class CISScrollHero extends HTMLElement {

    connectedCallback() {

      if (this._cisInitialized) return;

      this._cisInitialized = true;

      this.panels = Array.from(
        this.querySelectorAll('[data-cis-panel]')
      );

      this.steps = Array.from(
        this.querySelectorAll('[data-cis-step]')
      );

      if (!this.panels.length || !this.steps.length) {
        return;
      }

      this.currentStep = 0;
      this.currentPanel = null;
      this.desiredStep = 0;
      this.switchTimer = null;
      this.isSwitching = false;

      this.resetHero();

      this.observer = new IntersectionObserver(
        (entries) => {

          entries.forEach((entry) => {

            if (!entry.isIntersecting) return;

            const step = Number(
              entry.target.dataset.cisStep
            );

            if (Number.isNaN(step)) return;

            this.requestStep(step);

          });

        },
        {
          root: null,
          rootMargin: '-46% 0px -46% 0px',
          threshold: 0
        }
      );

      this.steps.forEach((step) => {
        this.observer.observe(step);
      });

    }


    disconnectedCallback() {

      if (this.observer) {
        this.observer.disconnect();
      }

      if (this.switchTimer) {
        window.clearTimeout(this.switchTimer);
      }

      this._cisInitialized = false;

    }


    getState(step) {

      const states = {

        0: {
          panel: null,
          struck: false
        },

        1: {
          panel: 0,
          struck: false
        },

        2: {
          panel: 0,
          struck: true
        },

        3: {
          panel: 1,
          struck: false
        },

        4: {
          panel: 1,
          struck: true
        },

        5: {
          panel: 2,
          struck: false
        },

        6: {
          panel: 2,
          struck: true
        },

        7: {
          panel: 3,
          struck: false
        },

        8: {
          panel: 3,
          struck: true
        },

        9: {
          panel: 4,
          struck: false
        }

      };

      return states[step] || states[0];

    }


    resetHero() {

      if (this.switchTimer) {
        window.clearTimeout(this.switchTimer);
      }

      this.switchTimer = null;

      this.currentStep = 0;
      this.currentPanel = null;
      this.desiredStep = 0;
      this.isSwitching = false;

      this.panels.forEach((panel) => {

        panel.classList.remove(
          'is-active',
          'is-struck',
          'is-leaving'
        );

      });

    }


    requestStep(step) {

      this.desiredStep = step;

      const targetState =
        this.getState(step);


      if (
        this.currentPanel !== null &&
        targetState.panel === this.currentPanel &&
        !this.isSwitching
      ) {

        this.applyState(step);

        return;

      }


      if (
        this.currentPanel === null &&
        !this.isSwitching
      ) {

        this.applyState(step);

        return;

      }


      if (
        targetState.panel !== this.currentPanel
      ) {

        this.beginPanelSwitch();

      }

    }


    beginPanelSwitch() {

      if (this.isSwitching) {
        return;
      }

      this.isSwitching = true;


      if (this.currentPanel !== null) {

        const oldPanel =
          this.panels[this.currentPanel];

        oldPanel.classList.add(
          'is-leaving'
        );

        oldPanel.classList.remove(
          'is-active'
        );

      }


      this.switchTimer =
        window.setTimeout(() => {

          this.panels.forEach((panel) => {

            panel.classList.remove(
              'is-active',
              'is-struck',
              'is-leaving'
            );

          });

          this.currentPanel = null;
          this.isSwitching = false;
          this.switchTimer = null;

          this.applyState(
            this.desiredStep
          );

        }, 620);

    }


    applyState(step) {

      const state =
        this.getState(step);

      this.currentStep = step;


      if (state.panel === null) {

        this.panels.forEach((panel) => {

          panel.classList.remove(
            'is-active',
            'is-struck',
            'is-leaving'
          );

        });

        this.currentPanel = null;

        return;

      }


      const activePanel =
        this.panels[state.panel];


      this.panels.forEach(
        (panel, index) => {

          if (index !== state.panel) {

            panel.classList.remove(
              'is-active',
              'is-struck',
              'is-leaving'
            );

          }

        }
      );


      activePanel.classList.remove(
        'is-leaving'
      );

      activePanel.classList.add(
        'is-active'
      );

      activePanel.classList.toggle(
        'is-struck',
        state.struck
      );

      this.currentPanel =
        state.panel;

    }

  }


  customElements.define(
    'cis-scroll-hero',
    CISScrollHero
  );

}